import React from 'react';
import { Text, Icon, Flex } from '@qga/roo-ui/components';
import type { Offer } from 'types/property';
import { GetShowCtaMessage } from 'lib/analytics/eventsMap/helpers/GetShowCtaMessage';
import { getRoomAvailabilityMessageStandard, getRoomAvailabilityMessageForOffer } from './getRoomAvailabilityMessage';

type CombinedAvailabilityMessageProps = Required<Pick<Offer, 'allocationsAvailable'>> & {
  mt?: number;
  isOffer?: boolean;
};

const RoomsAvailabilityMessage = ({ allocationsAvailable, mt = 0, isOffer = false }: CombinedAvailabilityMessageProps) => {
  const showMessage = GetShowCtaMessage(allocationsAvailable);

  if (!showMessage) {
    return null;
  }

  const message = isOffer
    ? getRoomAvailabilityMessageForOffer(allocationsAvailable)
    : getRoomAvailabilityMessageStandard(allocationsAvailable);

  return (
    <Flex color="brand.primary" alignItems="center" gap="1" mt={mt} data-testid="rooms-availability-message">
      <Icon name="errorOutline" size={16} />
      <Text fontWeight="bold">{message}</Text>
    </Flex>
  );
};

export default RoomsAvailabilityMessage;
